// Generated types for MBSE_Part
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { SysMLElementReadAPI, SysMLElementWriteAPI } from '../../sysml/types/sysmlelement';
import { SysMLElementReadAPISchemaObject, SysMLElementWriteAPISchemaObject } from '../../sysml/types/sysmlelement';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface MBSE_PartReadAPI extends SysMLElementReadAPI {
  category?: string | null;
  group?: string | null;
}

export interface MBSE_PartWriteAPI extends SysMLElementWriteAPI {
  category?: string | null;
  group?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const MBSE_PartReadAPISchema: z.ZodType<MBSE_PartReadAPI> = SysMLElementReadAPISchemaObject.extend({
  category: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
}).passthrough();

export const MBSE_PartWriteAPISchema: z.ZodType<MBSE_PartWriteAPI> = SysMLElementWriteAPISchemaObject.extend({
  category: z.string().nullable().optional(),
  group: z.string().nullable().optional(),
}).passthrough();
